// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__LR3cn","inputDescription":"styles_inputDescription__3oXsu"};